<template>
  <div class="machine-image-wrapper">
    <div class="machine-image-disturber">
      <div
        v-bind:class="{
          'first-disturber': resultIndex === 0
        }"
        class="machine-image-disturber-background"
      ></div>
      <div class="machine-image-disturber-text">
        {{ randomPercentNumber }}%<br />passend
      </div>
    </div>
    <img
      class="machine-image"
      v-bind:src="result.image"
      v-bind:alt="result.maschinenbezeichnung"
    />
    <div class="full-service">
      <i class="icon-ja" aria-hidden="true"></i
      ><span class="full-service-text">Full Service mgl.</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    resultIndex: {
      type: Number,
      default: 0
    },
    randomPercentNumber: {
      type: Number,
      default: 0
    }
  }
}
</script>
